export default __webpack_public_path__ + "static/media/cmbh-project.4d141b03.jpg";